import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Dialog,
  DialogContent,
  FormControl,
} from "@mui/material";
import { ChevronLeft } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../../api/api";
import { Order_summary } from "../../api/urls";
// import { useDispatch } from "react-redux";
// import { setWalletBalance } from "../../Redux/Wallet";
import { toast } from "react-toastify";

const PaymentPopupCheckout = ({
  onClose,
  skipPayment,
  // setOpenPopup,
  openPopup,
}) => {
  const navigate = useNavigate();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const cart = useSelector((state) => state.cart);
  const location = useLocation();
  const isBuyNow = location.state?.isBuyNow || false;
  const buyNowPayload = useSelector((state) => state.cart.buyNowData);
  const skip = useSelector((state) => state.cart.skipPaymentPopup);
  const quantityBuyNow = location.state?.quantity;

  const totals = location.state?.totals || {};
  const paymentOptions = location.state?.paymentOptions || {};

  // const isCreditOnlyCovering =
  //   paymentOptions.credit &&
  //   !paymentOptions.wallet &&
  //   !paymentOptions.points &&
  //   totals.finalTotal === 0

  // const address = {
  //   id: cart.shipping_id,
  // };

  const handleSubmit = async () => {
    const shopPayload = {
      payment_method: paymentMethod,
      shipping_id: cart.shipping_id,
      billing_id: cart.billing_id,
      company_name: cart.company_name,
      gstin_number: cart.gstin_number,
      pan_number: cart.pan_number,
      is_company: cart.is_company,
      // amount: totals.finalTotal,

      points: cart.points,
      wallet: cart.wallet,
      credit: cart.credit,
    };

    // if (!Array.isArray(cart.cartIds) || cart.cartIds.length === 0) {
    //   return alert("Your cart is empty");
    // }

    setIsSubmitting(true);

    try {
      const orderData = isBuyNow
        ? {
            // product: buyNowPayload.product,
            hexcolor: buyNowPayload.selected_color || null,
            size_label: buyNowPayload.selected_size || null,
            quantity: quantityBuyNow,
            product: buyNowPayload.id,
            ...shopPayload,
          }
        : {
            cart: cart.cartIds
              ?.filter((id) => id != null)
              .map((id) => id.toString()),
            ...shopPayload,
          };

      const response = await api.post(Order_summary, orderData);
      // window.open(response?.data?.pay);
      window.location.href = response?.data?.pay;

      // navigate("/your_order");

      // window.location.href = response?.data?.pay;
    } catch (error) {
      // console.error("Payment error:", error);
      toast.error(
        `Payment failed: ${error.response?.data?.message || error.message}`,
      );
    }
    // finally {
    //   setIsSubmitting(false);
    // }
  };

  const handleBackClick = () => {
    if (isBuyNow) {
      navigate("/buy_now");
    } else {
      navigate("/shop_cart");
    }
    // navigate(-1);
  };
  useEffect(() => {
    const creditBalance = location.state?.credit?.balance || 0;
    const totalToPay = totals?.finalTotal || 0;

    const creditFullyCovers =
      paymentOptions?.credit && creditBalance >= totalToPay;

    if (skip && creditFullyCovers) {
      handleSubmit("Credits");
    }
  }, [skip, totals, paymentOptions, location.state]);

  return (
    <Dialog open={openPopup} fullWidth maxWidth="xs" onClose={onClose}>
      <DialogContent>
        <Box p={3}>
          <Box
            display="flex"
            alignItems="center"
            mb={3}
            onClick={handleBackClick}
            sx={{ cursor: "pointer" }}
          >
            <ChevronLeft />
            {!isSubmitting && (
              <Typography variant="body1">Back to Store</Typography>
            )}
          </Box>

          <Typography variant="h6" gutterBottom>
            Select Payment Method
          </Typography>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <RadioGroup
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <FormControlLabel
                value="Cash On Delivery"
                control={<Radio />}
                label="Cash on Delivery"
              />
              <FormControlLabel
                value="Online"
                control={<Radio />}
                label="Online Payment"
              />
            </RadioGroup>
          </FormControl>

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={!paymentMethod || isSubmitting}
            sx={{
              backgroundColor: "#000",
              "&:hover": { backgroundColor: "#333" },
            }}
          >
            {isSubmitting ? "Processing..." : "Proceed"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentPopupCheckout;
